import { IQuestion } from "../types";

export enum ACTIONS {
  ADD_QUESTION,
  DELETE_QUESTION,
  CHANGE_QUESTIONS,
  CHANGE_MIN_CORRECT_ANSWERS_COUNT,
  TOGGLE_QUESTION_FORM_OPEN,
  ADD_ANSWER_OPTION,
  CHANGE_QUESTIONS_LIST_ORDER
}

export interface AddQuestion {
  type: ACTIONS.ADD_QUESTION;
  payload: {
    question: IQuestion;
  };
}

export interface DeleteQuestion {
  type: ACTIONS.DELETE_QUESTION;
  payload: {
    id: string;
  };
}

export interface ChangeQuestion {
  type: ACTIONS.CHANGE_QUESTIONS;
  payload: {
    question: IQuestion;
  };
}

export interface ChangeMinCorrectAnswersCount {
  type: ACTIONS.CHANGE_MIN_CORRECT_ANSWERS_COUNT;
  payload: {
    correctAnswersCount: number;
  };
}

export interface ToggleQuestionFormOpen {
  type: ACTIONS.TOGGLE_QUESTION_FORM_OPEN;
  payload: {
    isOpen: boolean;
  };
}

export interface ChangeQuestionsListOrder {
  type: ACTIONS.CHANGE_QUESTIONS_LIST_ORDER;
  payload: {
    questions: IQuestion[];
  };
}

export const toggleQuestionFormOpen = (isOpen: boolean): ToggleQuestionFormOpen => {
  return {
    type: ACTIONS.TOGGLE_QUESTION_FORM_OPEN,
    payload: {
      isOpen
    }
  };
};

export const addQuestion = (question: IQuestion): AddQuestion => {
  return {
    type: ACTIONS.ADD_QUESTION,
    payload: {
      question
    }
  };
};

export const deleteQuestion = (id: string): DeleteQuestion => {
  return {
    type: ACTIONS.DELETE_QUESTION,
    payload: {
      id
    }
  };
};

export const changeQuestion = (question: IQuestion): ChangeQuestion => {
  return {
    type: ACTIONS.CHANGE_QUESTIONS,
    payload: {
      question
    }
  };
};

export const changeMinCorrectAnswersCount = (correctAnswersCount: number): ChangeMinCorrectAnswersCount => {
  return {
    type: ACTIONS.CHANGE_MIN_CORRECT_ANSWERS_COUNT,
    payload: {
      correctAnswersCount
    }
  };
};

export const changeQuestionsListOrder = (questions: IQuestion[]): ChangeQuestionsListOrder => {
  return {
    type: ACTIONS.CHANGE_QUESTIONS_LIST_ORDER,
    payload: {
      questions
    }
  };
};

export type TestActions = AddQuestion | DeleteQuestion | ChangeQuestion | ChangeMinCorrectAnswersCount | ToggleQuestionFormOpen | ChangeQuestionsListOrder;
